var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaginationPreviousPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.273438 8.35156L5.41406 14.2031C5.85156 14.6042 6.27083 14.6042 6.67188 14.2031C7.10938 13.8021 7.10938 13.3828 6.67188 12.9453L2.02344 7.69531L6.67188 2.5C7.10938 2.0625 7.10938 1.64323 6.67188 1.24219C6.27083 0.804688 5.85156 0.804688 5.41406 1.24219L0.273438 7.09375C0.0911458 7.27604 0 7.49479 0 7.75C0 7.96875 0.0911458 8.16927 0.273438 8.35156ZM12.9609 2.5C13.362 2.0625 13.362 1.64323 12.9609 1.24219C12.5599 0.804688 12.1406 0.804688 11.7031 1.24219L6.50781 7.09375C6.36198 7.27604 6.28906 7.49479 6.28906 7.75C6.28906 7.96875 6.36198 8.16927 6.50781 8.35156L11.7031 14.2031C12.1406 14.6042 12.5599 14.6042 12.9609 14.2031C13.362 13.8021 13.362 13.3828 12.9609 12.9453L8.3125 7.69531L12.9609 2.5Z",
    fill: "#888888"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginationPreviousPage);
export default __webpack_public_path__ + "static/media/pagination-previous-page.6d43db6a2077b4f7909b9cf06e0f21b5.svg";
export { ForwardRef as ReactComponent };